export default __webpack_public_path__ + "static/2-36864d4341ac638c98d9ae535b09f858.jpg";